import { BrokenSearchIcon } from "@mlpa/core-ui-core-open_ocean_ui";
import { NoFilterResultsOverlayProps } from "@mlpa/core-ui-core-open_ocean_ui/Organisms/Tables";
import translations from "translations";

const useNoDataOverlayProps = (handleResetFilters: () => void): NoFilterResultsOverlayProps => {
  const {
    noResultsMessage,
    helperMessagesNoData: { reviewFilters, broadenCriteria, checkCombinations, chckSpelling, differentAttribute },
    resetFilters,
  } = translations.globals.table;

  return {
    icon: <BrokenSearchIcon />,
    title: noResultsMessage,
    helperTextList: [reviewFilters, broadenCriteria, checkCombinations, chckSpelling, differentAttribute],
    resetLinkButtonProps: {
      title: resetFilters,
      onClick: handleResetFilters,
    },
  };
};

export default useNoDataOverlayProps;
